import { PAYMENT_GENERATOR_PAYMENT_MODES } from '../data/payment-generator.data';

export type PaymentGeneratorReportType = 'selected' | 'pre-billing' | 'post-billing' | 'submission';
export type PaymentGeneratorPaymentMode = typeof PAYMENT_GENERATOR_PAYMENT_MODES[number]['id'];
